import ECheckPaymentDetailsTable from './ECheckPaymentDetailsTable';

export default ECheckPaymentDetailsTable;
